// Self Intro Media
export const CREATE_SELF_INTRO_MEDIA = "CREATE_SELF_INTRO_MEDIA";
export const CREATE_SELF_INTRO_MEDIA_SUCCESS =
  "CREATE_SELF_INTRO_MEDIA_SUCCESS";
export const CREATE_SELF_INTRO_MEDIA_FAILURE =
  "CREATE_SELF_INTRO_MEDIA_FAILURE";

export const FETCH_SELF_INTRO_MEDIA = "FETCH_SELF_INTRO_MEDIA";
export const FETCH_SELF_INTRO_MEDIA_SUCCESS = "FETCH_SELF_INTRO_MEDIA_SUCCESS";
export const FETCH_SELF_INTRO_MEDIA_FAILURE = "FETCH_SELF_INTRO_MEDIA_FAILURE";

export const DELETE_SELF_INTRO_MEDIA = "DELETE_SELF_INTRO_MEDIA";
export const DELETE_SELF_INTRO_MEDIA_SUCCESS =
  "DELETE_SELF_INTRO_MEDIA_SUCCESS";
export const DELETE_SELF_INTRO_MEDIA_FAILURE =
  "DELETE_SELF_INTRO_MEDIA_FAILURE";

export const UPDATE_SELF_INTRO_MEDIA = "UPDATE_SELF_INTRO_MEDIA";
export const UPDATE_SELF_INTRO_MEDIA_SUCCESS =
  "UPDATE_SELF_INTRO_MEDIA_SUCCESS";
export const UPDATE_SELF_INTRO_MEDIA_FAILURE =
  "UPDATE_SELF_INTRO_MEDIA_FAILURE";

// Work Experience Projects
export const CREATE_PROJECT_MEDIA = "CREATE_PROJECT_MEDIA";
export const CREATE_PROJECT_MEDIA_SUCCESS = "CREATE_PROJECT_MEDIA_SUCCESS";
export const CREATE_PROJECT_MEDIA_FAILURE = "CREATE_PROJECT_MEDIA_FAILURE";

export const FETCH_PROJECT_MEDIA = "FETCH_PROJECT_MEDIA";
export const FETCH_PROJECT_MEDIA_SUCCESS = "FETCH_PROJECT_MEDIA_SUCCESS";
export const FETCH_PROJECT_MEDIA_FAILURE = "FETCH_PROJECT_MEDIA_FAILURE";

export const FETCH_PROJECT_MEDIA_LIST = "FETCH_PROJECT_MEDIA_LIST";
export const FETCH_PROJECT_MEDIA_LIST_SUCCESS =
  "FETCH_PROJECT_MEDIA_LIST_SUCCESS";
export const FETCH_PROJECT_MEDIA_LIST_FAILURE =
  "FETCH_PROJECT_MEDIA_LIST_FAILURE";

export const DELETE_PROJECT_MEDIA = "DELETE_PROJECT_MEDIA";
export const DELETE_PROJECT_MEDIA_SUCCESS = "DELETE_PROJECT_MEDIA_SUCCESS";
export const DELETE_PROJECT_MEDIA_FAILURE = "DELETE_PROJECT_MEDIA_FAILURE";

export const UPDATE_PROJECT_MEDIA = "UPDATE_PROJECT_MEDIA";
export const UPDATE_PROJECT_MEDIA_SUCCESS = "UPDATE_PROJECT_MEDIA_SUCCESS";
export const UPDATE_PROJECT_MEDIA_FAILURE = "UPDATE_PROJECT_MEDIA_FAILURE";

// Candidate Details: Details, Work Experience, Education, Certifications, Languages
export const FETCH_CANDIDATE_WORK_EXPERIENCE =
  "FETCH_CANDIDATE_WORK_EXPERIENCE";
export const FETCH_CANDIDATE_WORK_EXPERIENCE_SUCCESS =
  "FETCH_CANDIDATE_WORK_EXPERIENCE_SUCCESS";
export const FETCH_CANDIDATE_WORK_EXPERIENCE_FAILURE =
  "FETCH_CANDIDATE_WORK_EXPERIENCE_FAILURE";

export const DELETE_CANDIDATE_WORK_EXPERIENCE =
  "DELETE_CANDIDATE_WORK_EXPERIENCE";
export const DELETE_CANDIDATE_WORK_EXPERIENCE_SUCCESS =
  "DELETE_CANDIDATE_WORK_EXPERIENCE_SUCCESS";
export const DELETE_CANDIDATE_WORK_EXPERIENCE_FAILURE =
  "DELETE_CANDIDATE_WORK_EXPERIENCE_FAILURE";

export const FETCH_CANDIDATE_EDUCATION = "FETCH_CANDIDATE_EDUCATION";
export const FETCH_CANDIDATE_EDUCATION_SUCCESS =
  "FETCH_CANDIDATE_EDUCATION_SUCCESS";
export const FETCH_CANDIDATE_EDUCATION_FAILURE =
  "FETCH_CANDIDATE_EDUCATION_FAILURE";

export const DELETE_CANDIDATE_EDUCATION = "DELETE_CANDIDATE_EDUCATION";
export const DELETE_CANDIDATE_EDUCATION_SUCCESS =
  "DELETE_CANDIDATE_EDUCATION_SUCCESS";
export const DELETE_CANDIDATE_EDUCATION_FAILURE =
  "DELETE_CANDIDATE_EDUCATION_FAILURE";

export const FETCH_CANDIDATE_CERTIFICATIONS = "FETCH_CANDIDATE_CERTIFICATIONS";
export const FETCH_CANDIDATE_CERTIFICATIONS_SUCCESS =
  "FETCH_CANDIDATE_CERTIFICATIONS_SUCCESS";
export const FETCH_CANDIDATE_CERTIFICATIONS_FAILURE =
  "FETCH_CANDIDATE_CERTIFICATIONS_FAILURE";

export const DELETE_CANDIDATE_CERTIFICATIONS =
  "DELETE_CANDIDATE_CERTIFICATIONS";
export const DELETE_CANDIDATE_CERTIFICATIONS_SUCCESS =
  "DELETE_CANDIDATE_CERTIFICATIONS_SUCCESS";
export const DELETE_CANDIDATE_CERTIFICATIONS_FAILURE =
  "DELETE_CANDIDATE_CERTIFICATIONS_FAILURE";

// Retrieve Public Links
export const FETCH_PUBLIC_CANDIDATE = "FETCH_PUBLIC_CANDIDATE";
export const FETCH_PUBLIC_CANDIDATE_SUCCESS = "FETCH_PUBLIC_CANDIDATE_SUCCESS";
export const FETCH_PUBLIC_CANDIDATE_FAILURE = "FETCH_PUBLIC_CANDIDATE_FAILURE";

export const FETCH_PUBLIC_WORK_EXPERIENCE = "FETCH_PUBLIC_WORK_EXPERIENCE";
export const FETCH_PUBLIC_WORK_EXPERIENCE_SUCCESS =
  "FETCH_PUBLIC_WORK_EXPERIENCE_SUCCESS";
export const FETCH_PUBLIC_WORK_EXPERIENCE_FAILURE =
  "FETCH_PUBLIC_WORK_EXPERIENCE_FAILURE";

export const FETCH_PUBLIC_EDUCATION = "FETCH_PUBLIC_EDUCATION";
export const FETCH_PUBLIC_EDUCATION_SUCCESS = "FETCH_PUBLIC_EDUCATION_SUCCESS";
export const FETCH_PUBLIC_EDUCATION_FAILURE = "FETCH_PUBLIC_EDUCATION_FAILURE";

export const FETCH_PUBLIC_CERTIFICATIONS = "FETCH_PUBLIC_CERTIFICATIONS";
export const FETCH_PUBLIC_CERTIFICATIONS_SUCCESS =
  "FETCH_PUBLIC_CERTIFICATIONS_SUCCESS";
export const FETCH_PUBLIC_CERTIFICATIONS_FAILURE =
  "FETCH_PUBLIC_CERTIFICATIONS_FAILURE";

export const FETCH_PUBLIC_LANGUAGES = "FETCH_PUBLIC_LANGUAGES";
export const FETCH_PUBLIC_LANGUAGES_SUCCESS = "FETCH_PUBLIC_LANGUAGES_SUCCESS";
export const FETCH_PUBLIC_LANGUAGES_FAILURE = "FETCH_PUBLIC_LANGUAGES_FAILURE";
